import { constant } from 'lodash/fp';
import { combineReducers } from 'redux';

import { keyById } from '@mews/fp';
import { createReducer } from '@mews/framework';

import { BOOKING_RESTARTED } from '../../global/actionTypes';
import { AUTHORIZE_PAYMENT_CARD_SUCCEEDED } from './actionTypes';
import { PaymentCardAuthorization, PaymentCardAuthorizations, PaymentCardAuthorizationsData } from './types';

const dataInitialState: PaymentCardAuthorizationsData = {};

const dataReducer = createReducer(dataInitialState, {
    [AUTHORIZE_PAYMENT_CARD_SUCCEEDED]: (
        state: PaymentCardAuthorizationsData,
        paymentCardAuthorization: PaymentCardAuthorization
    ) => ({
        ...state,
        ...keyById([paymentCardAuthorization]),
    }),
    [BOOKING_RESTARTED]: constant(dataInitialState),
});

export const paymentCardAuthorizations = combineReducers<PaymentCardAuthorizations>({
    data: dataReducer,
});
